// Libraries
import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { Modal } from 'antd'

// Styles
import { Title, WrapperProfileImage, WrapperImageInput, WrapperImage, ProfileImageLabel, TrashIcon, WrapperImgTag, IconWrapper, ErrorText } from '../../../EditProfile/Inputs/styles.js'

// Constants
import { Text } from '../../../../constants/TextConstants'

const ImageInput = ({ name, title, style, ...props }) => {
  const { confirm } = Modal

  const showDeleteConfirm = (form) => {
    confirm({
      title: Text.DeleteProfileImage,
      centered: true,
      icon: '',
      okText: Text.Confirm,
      cancelText: Text.Cancel,
      onOk() {
        form.setFieldValue(name, null)
        form.setFieldValue('linkProfileImage', '')
      },
      onCancel() {
        form.setFieldError(name, false)
      }
    })
  }

  const getImageUrl = (form, isABlob) => {
    if (isABlob) {
      return URL.createObjectURL(form.values[name])
    }
    return `${form.values.linkProfileImage}?${performance.now()}`
  }

  const verifyImageFormat = (imageFile, form) => {
    const { type, size } = imageFile
    if (type.toLowerCase() !== 'image/jpeg') {
      form.setFieldError(name, Text.ProfileImageErrorIncorrectExtension)
      return
    }
    if (size > 2048000) {
      form.setFieldError(name, Text.ProfileImageErrorMaximumSize)
      return
    }
    form.setFieldError(name, false)
    form.setFieldValue(name, imageFile)
  }

  const ClickableTrashIcon = ({ form }) => (
    <IconWrapper>
      <TrashIcon onClick={() => showDeleteConfirm(form)} />
    </IconWrapper>
  )

  return (
    <Field id={name} name={name} {...props}>
      {({ field, form }) => {
        const imageValue = field.value
        const linkProfileImage = form.values.linkProfileImage
        const isEmptyImageValue = !imageValue || !(typeof imageValue === 'object' && imageValue.size)
        return (
          <WrapperProfileImage style={style}>
            <Title>{title}:</Title>
            <WrapperImageInput>
              <input
                {...props}
                id='file-input'
                type='file'
                accept='image/jpeg'
                onClick={(e) => {
                  e.target.value = null
                  form.setFieldError(name, false)
                }}
                onChange={(e) => verifyImageFormat(e.target.files[0], form)}
                style={{ display: 'none' }}
              />
              <ProfileImageLabel id='file-input-label' htmlFor='file-input'>
                {Text.SelectAFile}
              </ProfileImageLabel>
              {(!isEmptyImageValue || linkProfileImage) && (
                <WrapperImage>
                  <ClickableTrashIcon form={form} />
                  <WrapperImgTag>
                    <img
                      alt={Text.ProfileImage}
                      src={getImageUrl(form, !isEmptyImageValue)}
                      draggable="false"
                    />
                  </WrapperImgTag>
                </WrapperImage>
              )}
              {form.errors.uploadedImage && <ErrorText>{form.errors.uploadedImage}</ErrorText>}
            </WrapperImageInput>
          </WrapperProfileImage>
        )
      }}
    </Field>
  )
}

ImageInput.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  style: PropTypes.object,
  form: PropTypes.shape({
    values: PropTypes.object,
    setFieldValue: PropTypes.func,
    errors: PropTypes.object,
    setFieldError: PropTypes.func
  })
}

export default ImageInput
